import React, { Component } from 'react'
import styled from 'styled-components'
import { TextInput, Button } from 'advenio-components'
import { Form } from 'formsy-react-2' //eslint-disable-line


const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 16px;
  box-sizing: border-box;
  `

const ButtonsContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  `
const InputContainer = styled.div`
  width: 80%;
  `
const Span = styled.span`
    font-weight: bold;
  `
const TitleContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  `
const DeleteForm = styled(Form)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`

class DeleteStudentModal extends Component {
  constructor(props) {
    super(props)
    this.state = {
      comments: null,
    }
  }

  onChange = (model) => {
    this.setState({ comments: model.comments })
  }

  delete = () => {
    this.props.delete(this.props.activeId, this.state.comments)
  }
  render() {
    return (
      <Container>
        <DeleteForm onChange={this.onChange}>
          <TitleContainer>
            <span>{'¿Por qué decidieron no inscribir a '}<Span>{' '+this.props.student+' '}</Span>?</span>
          </TitleContainer>
          <InputContainer>
            <TextInput name="comments" textarea />
          </InputContainer>
          <ButtonsContainer>
            <Button onClick={this.props.closeModal}>Cancelar</Button>
            <Button danger onClick={this.delete}>Eliminar</Button>
          </ButtonsContainer>
        </DeleteForm>
      </Container>
    )
  }
}

export default DeleteStudentModal



// WEBPACK FOOTER //
// ./src/Containers/Inscriptions/DeleteStudentModal.jsx